import { EventLogger } from "@EspaceParkQC/sdk-call-center";
import { Badge, Button, Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger, ScrollArea, Separator } from "@EspaceParkQC/sdk-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function EventLoggerComponent(): React.ReactElement {
  const { t } = useTranslation("main");
  const [isMinimized, setIsMinimized] = useState(true);

  return (
    <EventLogger
      render={(data) => {
        return (
          <Drawer open={!isMinimized} onOpenChange={(open) => setIsMinimized(!open)}>
            <DrawerTrigger asChild>
              <Button variant="outline" className="w-fit text-xs rounded-none rounded-t-lg border-b-0 shadow-lg z-50 fixed bottom-0 left-2">
                {t("events-logger.event-logs")}
              </Button>
            </DrawerTrigger>
            <DrawerContent>
              <DrawerHeader className="flex justify-between items-start">
                <DrawerTitle>{t("events-logger.event-logs")}</DrawerTitle>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    className="text-xs rounded-lg shadow-lg"
                    onClick={() => {
                      const blob = new Blob([JSON.stringify(data.logs, null, 2)], { type: "application/json" });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `event-logs-${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.json`;
                      a.click();
                      URL.revokeObjectURL(url);
                    }}
                  >
                    {t("events-logger.download")}
                  </Button>
                  <Button variant="outline" size="sm" className="text-xs rounded-lg shadow-lg">
                    {t("events-logger.copy-to-clipboard")}
                  </Button>
                </div>
              </DrawerHeader>
              <ScrollArea className="h-[500px] p-4">
                <div className="space-y-4">
                  {data.logs.map((log, index) => (
                    <div key={log.id}>
                      <div className="space-y-3">
                        <div className="flex items-center gap-2 flex-wrap">
                          <Badge variant={log.category === "call" ? "default" : log.category === "janus" ? "secondary" : "outline"}>
                            {log.category}
                          </Badge>
                          <Badge variant="outline">{log.type}</Badge>
                          <span className="text-xs text-muted-foreground ml-auto">{log.timestamp.toLocaleTimeString()}</span>
                        </div>
                        <div className="rounded-md border border-border bg-muted p-3">
                          <pre className="text-xs overflow-x-auto">{JSON.stringify(log.data, null, 2)}</pre>
                        </div>
                      </div>
                      {index < data.logs.length - 1 && <Separator className="mt-4" />}
                    </div>
                  ))}
                </div>
              </ScrollArea>
            </DrawerContent>
          </Drawer>
        );
      }}
    />
  );
}
